/* eslint-disable */
import Long from "long";
import _m0 from "protobufjs/minimal";
import { TriggerArgs_TimerCallback } from "../../trigger_args";

export const protobufPackage = "complimentary_actions";

/**
 * Copy of skills.MissionControl message.
 * NOTE(duncan): This is a copy because using the `MissionControl` defined in `mission.proto`
 * results in a circular reference and some additional problems with `MissionControl` now being both
 * a `type` and `input` in the GQL schema. Both of these are solvable problems (this abandoned PR
 * addresses the circular reference issue: https://github.com/Skydio/aircam/pull/60871), but I made
 * the decision to just copy the message definition to avoid solving these problems just for the
 * sake of mission testing. If this turns out to have been a bad decision, you are encouraged to
 * blame me, deprecate this action, and make a new SendMissionControlV2 that references the original
 * MissionControl assuming the aforementioned problems are solved.
 */
export interface MissionControlCopyForComplimentaryActions {
  utime: number;
  command: MissionControlCopyForComplimentaryActions_ControlType;
  /** Uuid of the action affected by this control. Currently used for SKIP_TO_WAYPOINT */
  actionUuid: string;
}

export enum MissionControlCopyForComplimentaryActions_ControlType {
  INVALID = 0,
  /** START - Start the mission if the mission is paused, or hasn't started yet. */
  START = 1,
  /** PAUSE - Pause the mission (stops the vehicle) */
  PAUSE = 2,
  /** ABORT - Cancel the mission and execute the completed mission behavior. */
  ABORT = 3,
  /** RESUME - Resume the current mission */
  RESUME = 5,
  /** REQUEST_MISSION - Request the current mission definition */
  REQUEST_MISSION = 6,
  /**
   * ABORT_AUTONOMOUS - Autonomous abort that comes from an internal system, not user commanded
   * Note: an autonomous abort only marks IN_PROGRESS as finished. This means that
   * the mission will still complete the post mission action if possible
   */
  ABORT_AUTONOMOUS = 7,
  /** LAND_IN_PLACE - Ends the mission and lands in place */
  LAND_IN_PLACE = 8,
  /** SKIP_TO_WAYPOINT - Skips to a given waypoint in the current mission */
  SKIP_TO_WAYPOINT = 9,
  UNRECOGNIZED = -1,
}

export function missionControlCopyForComplimentaryActions_ControlTypeFromJSON(
  object: any,
): MissionControlCopyForComplimentaryActions_ControlType {
  switch (object) {
    case 0:
    case "INVALID":
      return MissionControlCopyForComplimentaryActions_ControlType.INVALID;
    case 1:
    case "START":
      return MissionControlCopyForComplimentaryActions_ControlType.START;
    case 2:
    case "PAUSE":
      return MissionControlCopyForComplimentaryActions_ControlType.PAUSE;
    case 3:
    case "ABORT":
      return MissionControlCopyForComplimentaryActions_ControlType.ABORT;
    case 5:
    case "RESUME":
      return MissionControlCopyForComplimentaryActions_ControlType.RESUME;
    case 6:
    case "REQUEST_MISSION":
      return MissionControlCopyForComplimentaryActions_ControlType.REQUEST_MISSION;
    case 7:
    case "ABORT_AUTONOMOUS":
      return MissionControlCopyForComplimentaryActions_ControlType.ABORT_AUTONOMOUS;
    case 8:
    case "LAND_IN_PLACE":
      return MissionControlCopyForComplimentaryActions_ControlType.LAND_IN_PLACE;
    case 9:
    case "SKIP_TO_WAYPOINT":
      return MissionControlCopyForComplimentaryActions_ControlType.SKIP_TO_WAYPOINT;
    case -1:
    case "UNRECOGNIZED":
    default:
      return MissionControlCopyForComplimentaryActions_ControlType.UNRECOGNIZED;
  }
}

export function missionControlCopyForComplimentaryActions_ControlTypeToJSON(
  object: MissionControlCopyForComplimentaryActions_ControlType,
): string {
  switch (object) {
    case MissionControlCopyForComplimentaryActions_ControlType.INVALID:
      return "INVALID";
    case MissionControlCopyForComplimentaryActions_ControlType.START:
      return "START";
    case MissionControlCopyForComplimentaryActions_ControlType.PAUSE:
      return "PAUSE";
    case MissionControlCopyForComplimentaryActions_ControlType.ABORT:
      return "ABORT";
    case MissionControlCopyForComplimentaryActions_ControlType.RESUME:
      return "RESUME";
    case MissionControlCopyForComplimentaryActions_ControlType.REQUEST_MISSION:
      return "REQUEST_MISSION";
    case MissionControlCopyForComplimentaryActions_ControlType.ABORT_AUTONOMOUS:
      return "ABORT_AUTONOMOUS";
    case MissionControlCopyForComplimentaryActions_ControlType.LAND_IN_PLACE:
      return "LAND_IN_PLACE";
    case MissionControlCopyForComplimentaryActions_ControlType.SKIP_TO_WAYPOINT:
      return "SKIP_TO_WAYPOINT";
    case MissionControlCopyForComplimentaryActions_ControlType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface SendMissionControlActionArgs {
  trigger:
    | TriggerArgs_TimerCallback
    | undefined;
  /** Mission control to publish. */
  missionControl: MissionControlCopyForComplimentaryActions | undefined;
}

function createBaseMissionControlCopyForComplimentaryActions(): MissionControlCopyForComplimentaryActions {
  return { utime: 0, command: 0, actionUuid: "" };
}

export const MissionControlCopyForComplimentaryActions = {
  encode(message: MissionControlCopyForComplimentaryActions, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.utime !== 0) {
      writer.uint32(16).int64(message.utime);
    }
    if (message.command !== 0) {
      writer.uint32(8).int32(message.command);
    }
    if (message.actionUuid !== "") {
      writer.uint32(26).string(message.actionUuid);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): MissionControlCopyForComplimentaryActions {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMissionControlCopyForComplimentaryActions();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2:
          if (tag !== 16) {
            break;
          }

          message.utime = longToNumber(reader.int64() as Long);
          continue;
        case 1:
          if (tag !== 8) {
            break;
          }

          message.command = reader.int32() as any;
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.actionUuid = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MissionControlCopyForComplimentaryActions {
    return {
      utime: isSet(object.utime) ? globalThis.Number(object.utime) : 0,
      command: isSet(object.command)
        ? missionControlCopyForComplimentaryActions_ControlTypeFromJSON(object.command)
        : 0,
      actionUuid: isSet(object.actionUuid) ? globalThis.String(object.actionUuid) : "",
    };
  },

  toJSON(message: MissionControlCopyForComplimentaryActions): unknown {
    const obj: any = {};
    if (message.utime !== 0) {
      obj.utime = Math.round(message.utime);
    }
    if (message.command !== 0) {
      obj.command = missionControlCopyForComplimentaryActions_ControlTypeToJSON(message.command);
    }
    if (message.actionUuid !== "") {
      obj.actionUuid = message.actionUuid;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MissionControlCopyForComplimentaryActions>, I>>(
    base?: I,
  ): MissionControlCopyForComplimentaryActions {
    return MissionControlCopyForComplimentaryActions.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MissionControlCopyForComplimentaryActions>, I>>(
    object: I,
  ): MissionControlCopyForComplimentaryActions {
    const message = createBaseMissionControlCopyForComplimentaryActions();
    message.utime = object.utime ?? 0;
    message.command = object.command ?? 0;
    message.actionUuid = object.actionUuid ?? "";
    return message;
  },
};

function createBaseSendMissionControlActionArgs(): SendMissionControlActionArgs {
  return { trigger: undefined, missionControl: undefined };
}

export const SendMissionControlActionArgs = {
  encode(message: SendMissionControlActionArgs, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.trigger !== undefined) {
      TriggerArgs_TimerCallback.encode(message.trigger, writer.uint32(10).fork()).ldelim();
    }
    if (message.missionControl !== undefined) {
      MissionControlCopyForComplimentaryActions.encode(message.missionControl, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SendMissionControlActionArgs {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSendMissionControlActionArgs();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.trigger = TriggerArgs_TimerCallback.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.missionControl = MissionControlCopyForComplimentaryActions.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SendMissionControlActionArgs {
    return {
      trigger: isSet(object.trigger) ? TriggerArgs_TimerCallback.fromJSON(object.trigger) : undefined,
      missionControl: isSet(object.missionControl)
        ? MissionControlCopyForComplimentaryActions.fromJSON(object.missionControl)
        : undefined,
    };
  },

  toJSON(message: SendMissionControlActionArgs): unknown {
    const obj: any = {};
    if (message.trigger !== undefined) {
      obj.trigger = TriggerArgs_TimerCallback.toJSON(message.trigger);
    }
    if (message.missionControl !== undefined) {
      obj.missionControl = MissionControlCopyForComplimentaryActions.toJSON(message.missionControl);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SendMissionControlActionArgs>, I>>(base?: I): SendMissionControlActionArgs {
    return SendMissionControlActionArgs.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SendMissionControlActionArgs>, I>>(object: I): SendMissionControlActionArgs {
    const message = createBaseSendMissionControlActionArgs();
    message.trigger = (object.trigger !== undefined && object.trigger !== null)
      ? TriggerArgs_TimerCallback.fromPartial(object.trigger)
      : undefined;
    message.missionControl = (object.missionControl !== undefined && object.missionControl !== null)
      ? MissionControlCopyForComplimentaryActions.fromPartial(object.missionControl)
      : undefined;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function longToNumber(long: Long): number {
  if (long.gt(globalThis.Number.MAX_SAFE_INTEGER)) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  return long.toNumber();
}

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any;
  _m0.configure();
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
